import PropTypes from 'prop-types';
import './FolderPlanCard.css';

/**
 * FolderPlanCard — shows the pending folder plan from the agent and lets
 * the user approve or cancel it with a single click.
 *
 * Props:
 *   plan        — { folders: [{path, document_count}], total_documents }
 *   onApply     — async () => void   called when user clicks "Apply"
 *   onCancel    — () => void         called when user clicks "Cancel"
 *   applying    — bool               true while the API call is in flight
 */
export default function FolderPlanCard({ plan, onApply, onCancel, applying }) {
  return (
    <div className="chat-message chat-message-assistant folder-plan-card">
      <div className="chat-message-header">
        <span className="chat-role">Arc</span>
        <span className="folder-plan-badge">📁 Folder Plan Ready</span>
      </div>
      <div className="chat-message-body">
        <p className="folder-plan-summary">
          Ready to organize <strong>{plan.total_documents}</strong> document
          {plan.total_documents !== 1 ? 's' : ''} into{' '}
          <strong>{plan.folders.length}</strong> folder
          {plan.folders.length !== 1 ? 's' : ''}:
        </p>
        <ul className="folder-plan-list">
          {plan.folders.map((f, i) => (
            <li key={i} className="folder-plan-item">
              <span className="folder-plan-path">{f.path}</span>
              <span className="folder-plan-count">{f.document_count} doc{f.document_count !== 1 ? 's' : ''}</span>
            </li>
          ))}
        </ul>
        <p className="folder-plan-note">
          Click <strong>Apply</strong> to move the documents now, or{' '}
          <strong>Cancel</strong> to skip (you can still ask the agent to apply it).
        </p>
      </div>
      <div className="folder-plan-actions">
        <button
          className="btn btn-primary"
          onClick={onApply}
          disabled={applying}
        >
          {applying ? 'Applying…' : 'Apply'}
        </button>
        <button
          className="btn btn-ghost"
          onClick={onCancel}
          disabled={applying}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

FolderPlanCard.propTypes = {
  plan: PropTypes.shape({
    folders: PropTypes.arrayOf(
      PropTypes.shape({
        path: PropTypes.string.isRequired,
        document_count: PropTypes.number.isRequired,
      })
    ).isRequired,
    total_documents: PropTypes.number.isRequired,
  }).isRequired,
  onApply: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  applying: PropTypes.bool,
};
